import React from 'react';

interface PageBodyProps {
  className?: string,
  children: React.ReactNode,
}

export const PageBody = (props: PageBodyProps) => {
  return (
    <div
      // The console caps and centres its main column rather than running edge
      // to edge. w-full + mx-auto keeps the existing flex chain intact (this is
      // still the scrolling flex child that ModelListPage sets `h-0` on).
      className={`page-body mx-auto box-border flex min-h-0 w-full max-w-[1600px] flex-1 flex-col overflow-auto px-4 sm:px-6 [@media(max-height:1000px)]:overflow-visible${props.className ? ` ${props.className}` : ''}`}
    >
      {props.children}
    </div>
  );
};
